var _path, _rect, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPort = function SvgPort(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.5 42h8v8h-8z",
    fill: "#1550af"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#acb9bf",
    height: 3,
    rx: 1,
    width: 3,
    x: 8,
    y: 44
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m43.286 12h9.428l6.286 40h-22z",
    fill: "#7aa5ea"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m34 52h28v10h-28z",
    fill: "#d3d3d3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m5.5 42v8l8-8z",
    fill: "#689ddd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3f4e56"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 3,
    rx: 1,
    width: 3,
    x: 56,
    y: 56
  }), /*#__PURE__*/React.createElement("rect", {
    height: 3,
    rx: 1,
    width: 3,
    x: 50,
    y: 56
  }), /*#__PURE__*/React.createElement("rect", {
    height: 3,
    rx: 1,
    width: 3,
    x: 43,
    y: 56
  }), /*#__PURE__*/React.createElement("rect", {
    height: 3,
    rx: 1,
    width: 3,
    x: 37,
    y: 56
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m10 44h-1a.99943.99943 0 0 0 -1 1v1a.99653.99653 0 0 0 .59143.90857l2.3172-2.3172a.99656.99656 0 0 0 -.90863-.59137z",
    fill: "#cdd1d3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m38.614 41.732 20.087 8.365-.382-2.431-18.121-7.546 16.061-5.56-.538-3.426-13.069-5.17 11.539-4.565-.467-2.971-10.901-3.45-.008.016-.321 2.045 9.463 2.995-10.592 4.191-.515 3.274 13.753 5.44-15.448 5.348z",
    fill: "#3f4e56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m21 12.5h2v10.5h-2z",
    fill: "#3f4e56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m19 22h6v4h-6z",
    fill: "#1db7ed"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m16 26h12v8h-12z",
    fill: "#ed4720"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m16 26v8l12-8z",
    fill: "#e87058"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m22.146 11-.34224-1.96094 26.15334-7.01953a.79833.79833 0 0 1 .72364.207 1.06489 1.06489 0 0 1 .31926.77347v7h-1.74356v-5.78027z",
    fill: "#3f4e56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m8.74341 60.20764a3.58327 3.58327 0 0 1 2.58374-1.20764c2.33179 0 2.33179 2 4.66357 2 2.3338 0 2.3338-2 4.66761-2a3.85755 3.85755 0 0 1 2.72137 1.317 4.55611 4.55611 0 0 0 1.92657-2.35175l4-8.96527h-26.30627l4 8.96527a4.56143 4.56143 0 0 0 1.74341 2.24239z",
    fill: "#3f4e56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m25.3291 62a4.17018 4.17018 0 0 1 -2.98535-1.24023 2.24741 2.24741 0 0 0 -3.36914 0 4.20726 4.20726 0 0 1 -5.9668-.001 2.23959 2.23959 0 0 0 -3.36035 0 4.20609 4.20609 0 0 1 -5.9668 0 2.25634 2.25634 0 0 0 -1.68066-.75877v-2a4.16529 4.16529 0 0 1 2.9834 1.24121 2.24067 2.24067 0 0 0 3.36133 0 4.20491 4.20491 0 0 1 5.96582 0 2.24187 2.24187 0 0 0 3.36328-.001 4.21312 4.21312 0 0 1 5.9707 0 2.24849 2.24849 0 0 0 3.37012 0 4.17018 4.17018 0 0 1 2.98535-1.24021v2a2.26223 2.26223 0 0 0 -1.68457.75977 4.17085 4.17085 0 0 1 -2.98633 1.24023z",
    fill: "#18aced"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m21 9h40v4h-40z",
    fill: "#afafaf"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPort, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/port.2a6f57e8.svg";
export { ForwardRef as ReactComponent };